export default __webpack_public_path__ + "static/media/8_2.43102e98.png";